import * as Application from "expo-application";

import { getLastLogTime } from "./fetchSecureStore";

import {
  type DiagnosticItem,
  DiagnosticStatus,
} from "@/schemas/app/diagnostic";

const fetchAppInfo = async (): Promise<DiagnosticItem[]> => {
  const appVersion = Application.nativeApplicationVersion || "Unknown";
  const appBuildVersion = Application.nativeBuildVersion || "Unknown";
  const appName = Application.applicationName || "Unknown";
  const appId = Application.applicationId || "Unknown";

  const lastLogTimeInfo = await getLastLogTime();

  return [
    {
      id: "appName",
      name: "App Name",
      value: appName,
      status:
        appName !== "Unknown" ? DiagnosticStatus.OK : DiagnosticStatus.ERROR,
    },
    {
      id: "appId",
      name: "App ID",
      value: appId,
      status:
        appId !== "Unknown" ? DiagnosticStatus.OK : DiagnosticStatus.ERROR,
    },
    {
      id: "appVersion",
      name: "App Version",
      value: appVersion,
      status:
        appVersion !== "Unknown" ? DiagnosticStatus.OK : DiagnosticStatus.ERROR,
    },
    {
      id: "appBuildVersion",
      name: "App Build Version",
      value: appBuildVersion,
      status:
        appBuildVersion !== "Unknown"
          ? DiagnosticStatus.OK
          : DiagnosticStatus.ERROR,
    },
    {
      id: "lastLogTime",
      name: "Last Device Log Time",
      value: lastLogTimeInfo.formattedTime,
      status: lastLogTimeInfo.status,
    },
  ];
};

export default fetchAppInfo;
